// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","SocialLinks":"Footer_SocialLinks__04dNo","leafs":"Footer_leafs__ys1Db","downText":"Footer_downText__hPSmh"};